import {
  INTERNAL_MATERIAL_PURPOSES,
  INTERNAL_MATERIAL_PURPOSE_OPTIONS,
} from '../../constants/internalMaterialPurposes';

/** Conserva los motivos libres históricos como detalle de Otro al editar un borrador. */
export const getSupplyOrderInternalReason = (order) => {
  const reason = (order.internal_reason || '').trim();
  const option = INTERNAL_MATERIAL_PURPOSE_OPTIONS.find((row) =>
    row.value === reason || row.label === reason);
  return {
    internal_reason: option?.value || (reason ? INTERNAL_MATERIAL_PURPOSES.OTHER : ''),
    internal_reason_detail: option
      ? order.internal_reason_detail || '' : reason,
  };
};
